module.exports = ":host {\n  position: relative;\n  width: 100%;\n  fill: #6e6e6f;\n  display: block; }\n  :host svg {\n    width: 100%;\n    display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-shared-features/feature/shared-component/svg/svg.style.scss
// module id = 674
// module chunks = 2